module.exports = __webpack_public_path__ + "static/media/CircleSectionGeometry.da93e103.svg";